import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import ActivitiesPage from './pages/ActivitiesPage'
import ActivityDetailPage from './pages/ActivityDetailPage'
import TeachingBaseDetailPage from './pages/TeachingBaseDetailPage'
import InternalEventsPage from './pages/InternalEventsPage'
import AboutPage from './pages/AboutPage'
import TimelinePage from './pages/TimelinePage'
import JoinPage from './pages/JoinPage'
import GalleryPage from './pages/GalleryPage'
import './styles/globals.css'

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            <Route path="/activities/summer-teaching/base/:baseSlug" element={<TeachingBaseDetailPage />} />
            <Route path="/activities/:slug" element={<ActivityDetailPage />} />
            <Route path="/internal-events" element={<InternalEventsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/timeline" element={<TimelinePage />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
